module.exports = __webpack_public_path__ + "img/banner2.03231adc.jpg";